import { Icon as i } from "../Icon/index.js";
import { LoadingIcon as s } from "../Loading/style.js";
import { SmartLink as $ } from "../SmartLink/index.js";
import { styled as t, css as n } from "styled-components";
import { skeletonFadeAnimation as d } from "../../styles/animation.js";
import { Colors as l } from "../../styles/colors/index.js";
import { Theme as o } from "../../styles/themes/index.js";
import { BodyHeavy as p } from "../../styles/typography/index.js";
const e = (r) => n`
  ${s} {
    background: linear-gradient(
      to bottom,
      rgb(${r}) 0%,
      ${o.colors.Juliet} 90%,
      ${o.colors.Juliet} 100%
    );
  }
`, c = t.div`
  position: absolute;
  right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: 3px solid rgb(${l.Silver});
  border-radius: 50%;

  ${s} {
    &::after,
    &:before {
      background-color: inherit;
    }
  }
`, u = n`
  background: rgb(${o.colors.Golf});
  border: none;
  color: rgb(${o.colors.Alpha});

  ${c} {
    border-color: rgb(${o.colors.Alpha});
    ${e(o.colors.Golf)}
  }

  &:hover:not(:disabled) {
    background: rgb(${o.colors.Golf});
    color: rgb(${o.colors.Alpha});
  }
`, a = t(i)`
  font-size: 24px;
  margin-right: 4px;
`, b = t(i)`
  font-size: 24px;
  margin-left: 4px;
`, h = n`
  background: rgb(${o.colors.Juliet});
  border: 1px solid rgb(${o.colors.Golf});
  color: rgb(${o.colors.Alpha});

  ${c} {
    border-color: rgb(${o.colors.Alpha});
    ${e(o.colors.Juliet)}
  }

  ${b}, ${a} {
    color: rgb(${o.colors.Alpha});
  }

  &:hover:not(:disabled) {
    background: rgb(${o.colors.Juliet});
    color: rgb(${o.colors.Alpha});
  }
`, f = n`
  background: rgb(${o.colors.Golf});
  border: none;
  color: rgb(${l.Gray});

  ${c} {
    border-color: rgb(${o.colors.Golf});
    ${e(o.colors.Golf)}
  }

  ${b}, ${a} {
    color: rgb(${l.Gray});
  }

  &:hover:not(:disabled) {
    background: rgb(${o.colors.Golf});
    color: rgb(${o.colors.Alpha});
  }
`, C = t.span``, m = n`
  width: 100%;
`, g = ({
  $sharped: r
}) => n`
  ${p}
  align-items: center;
  border-radius: ${r ? "4px" : "36px"};
  border: 0;
  box-sizing: border-box;
  color: rgb(${l.Porcelain});
  display: inline-flex;
  min-height: 32px;
  padding: 8px 24px;
  position: relative;
  justify-content: center;
  text-decoration: none;
`, x = t.button`
  ${g}
  cursor: pointer;
  background: rgb(${o.colors.Yankee});

  &:hover {
    background: rgb(${o.colors.AlphaAlpha});
    ${e(o.colors.AlphaAlpha)}
  }

  &:disabled {
    background: rgb(${o.colors.Golf});
    color: rgb(${l.Gray});
    i {
      color: rgb(${l.Gray});
    }

    ${c} {
      border-color: rgb(${o.colors.Golf});
      ${e(o.colors.Golf)}
    }
  }

  ${({ $inactive: r }) => r && f}
  ${({ $secondary: r }) => r && u}
  ${({ $light: r }) => r && h}
  ${({ $responsive: r }) => r && m}
`, I = t(x).attrs({ as: $ })``, J = t.div`
  ${g}
  ${d}
  width: ${({ width: r }) => r || "auto"};
`;
export {
  I as ButtonAsLink,
  x as ButtonContainer,
  c as ButtonLoading,
  J as ButtonSkeletonContainer,
  C as ButtonWithIconContent,
  a as LeftIcon,
  b as RightIcon,
  g as buttonBaseStyles,
  h as buttonLightStyles
};
